export const initialState = {
  activities: [
    {
      text: "Hello! Welcome. \n How can I help you with your accounting related queries?",
      origin: "bot",
      conditionstart: "start",
    },
  ],
  showModal: false,
  modalcontent: "",
  typingindicator: false,
  messages: [],
  cta: [],
  autocompleteData: [],
  isFirstTime: false,
  authToken: "",
  recentSearches: [],
  isMessageSubmitted: false,
  mode: "qna",
  source: "",
  transcription: "",
  prompts: [],
  // a nudge flow indicator
  nudgeFlow: false,
  channel: "",
};
